import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import "./ChatBot.css";

export function ChatBot() {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");
  const [started, setStarted] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const inputRef = useRef(null);
  const lastMsgRef = useRef(null);

  const UserName = "Kittu";

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!started) {
      setStarted(true);
      addMessage(
        `<span class="chatbot-msg-friend">${UserName}:</span> Hi ${name}! Ask Something About Krishna?`
      );
    }
  };

  const sendMessage = async () => {
    const userInputElem = inputRef.current;
    const userInput = userInputElem.value.trim();
    if (!userInput) return;

    addMessage(
      `<span class="chatbot-msg-user">You:</span> ${escapeHtml(userInput)}`
    );
    userInputElem.value = "";

    try {
      const response = await axios.post(
        "https://portfolio-server-91pj.onrender.com/chat",
        {
          prompt: userInput,
          name,
        }
      );

      addMessage(
        `<span class="chatbot-msg-friend">${UserName}:</span> ${escapeHtml(
          response.data.response
        )}`
      );
    } catch (error) {
      addMessage(
        `<span class="chatbot-msg-system">${UserName}: Sorry, I couldn't process your message.</span>`
      );
    }
  };

  const addMessage = (message) => {
    setChatMessages((prev) => [...prev, message]);
  };

  const escapeHtml = (text) =>
    text
      .replace(
        /[&<>"']/g,
        (m) =>
          ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
          }[m])
      )
      .replace(/\*\*/g, "")
      .replace(/(http[s]?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>');

  // 👇 Scroll to top of last message when chat updates
  useEffect(() => {
    if (lastMsgRef.current) {
      lastMsgRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [chatMessages]);

  return (
    <div className="chatbot-container">
      <div
        id="chatbot-bubble"
        title="Chat with your friend!"
        onClick={toggleChat}
      >
        💬
      </div>

      {isOpen && (
        <div id="chatbot-window">
          <div className="chatbot-header">
            <h1>Talk With Kittu</h1>
            <span className="chatbot-close" onClick={toggleChat}>
              ✕
            </span>
          </div>

          <div className="chatbot-interface">
            <h2>Chat</h2>
            <div className="chatbot-chat-box">
              {chatMessages.map((msg, idx) => (
                <div
                  key={idx}
                  ref={idx === chatMessages.length - 1 ? lastMsgRef : null}
                  dangerouslySetInnerHTML={{ __html: msg }}
                />
              ))}
            </div>
            <div className="chatbot-input-area">
              <input
                ref={inputRef}
                type="text"
                placeholder="Type your message here..."
                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              />
              <button onClick={sendMessage}>→</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
